import { IconButton, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ShapeLabelIcon } from '../../assets/icons/shape-label-icon.svg';
import { useViewer } from './ForgeViewer';
import SparkelIcon from './icon/SparkelIcon';

export default function ShapeLabelsButton(): React.ReactElement {
  const {
    showLabels: { isShowingLabels, setIsShowingLabels },
  } = useViewer();

  const { t } = useTranslation('project');

  const activeIconColor: [string, string] = ['teal.500', 'teal.200'];

  return (
    <Tooltip label={t('shape-labels-button')}>
      <IconButton
        aria-label="Shape Labels On/Off"
        icon={
          <SparkelIcon
            as={ShapeLabelIcon}
            color={isShowingLabels ? activeIconColor : undefined}
          />
        }
        isRound
        isActive={isShowingLabels}
        colorScheme={isShowingLabels ? 'teal' : 'gray'}
        variant={isShowingLabels ? 'toggle' : 'solid-no-transparent'}
        size="xs"
        onClick={() => {
          setIsShowingLabels(!isShowingLabels);
        }}
      />
    </Tooltip>
  );
}
